import React from 'react'
import ReactDOMServer from 'react-dom/server'
import {
  Star,
  Heart,
  House,
  User,
  Gear,
  Shield,
  Lock,
  Key,
  Check,
  X,
  Plus,
  Minus,
  MagnifyingGlass,
  ShoppingCart,
  CreditCard,
  Gift,
  Package,
  Truck,
  MapPin,
  Globe,
  Phone,
  Chat,
  Users,
  Camera,
  Image,
  File,
  Folder,
  Download,
  Upload,
  Share,
  Link,
} from '@phosphor-icons/react'
import { IconPack, IconDefinition, ExportArgs, svgStringToPng } from './types'

function formatDisplayName(name: string) {
  return name
    .replace(/Icon$/, '')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    .replace(/^./, (str) => str.toUpperCase())
}

// Map of icon names to their components
const iconMap = {
  Star,
  Heart,
  House,
  User,
  Gear,
  Shield,
  Lock,
  Key,
  Check,
  X,
  Plus,
  Minus,
  MagnifyingGlass,
  ShoppingCart,
  CreditCard,
  Gift,
  Package,
  Truck,
  MapPin,
  Globe,
  Phone,
  Chat,
  Users,
  Camera,
  Image,
  File,
  Folder,
  Download,
  Upload,
  Share,
  Link,
}

const phosphorIconsPack: IconPack = {
  name: 'Phosphor Icons',
  icons: Object.entries(iconMap).map(([name, icon]) => ({
    name,
    displayName: formatDisplayName(name),
    icon,
    pack: 'phosphor-icons',
  })),
  getIconComponent: (
    icon: IconDefinition,
    size?: number,
    color?: string,
    rotate?: number
  ) => {
    const IconComponent = icon.icon
    return (
      <IconComponent
        size={size || 24}
        color={color || 'currentColor'}
        weight="regular"
        style={{
          transform: rotate ? `rotate(${rotate}deg)` : undefined,
        }}
      />
    )
  },
  exportSVG: ({ icon, logo }: ExportArgs) => {
    const IconComponent = icon.icon
    const iconSize = logo.exactIconSize || 64
    const iconColor = logo.iconColor || '#000000'
    const bgColor = logo.backgroundColor || '#ffffff'
    const borderRadius = logo.borderRadius || 0
    const borderWidth = logo.borderWidth || 0
    const rotation = logo.rotate || 0
    const size = 256
    const iconX = 128 - iconSize / 2
    const iconY = 128 - iconSize / 2

    return ReactDOMServer.renderToStaticMarkup(
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x={borderWidth / 2}
          y={borderWidth / 2}
          width={size - borderWidth}
          height={size - borderWidth}
          rx={borderRadius}
          ry={borderRadius}
          fill={bgColor}
          stroke={iconColor}
          strokeWidth={borderWidth}
        />
        <g transform={`rotate(${rotation},128,128)`}>
          <IconComponent
            size={iconSize}
            color={iconColor}
            weight="regular"
            x={iconX}
            y={iconY}
          />
        </g>
      </svg>
    )
  },
  exportPNG: async ({ icon, logo }: ExportArgs) => {
    const svg = phosphorIconsPack.exportSVG?.({ icon, logo })
    if (!svg) return undefined
    return await svgStringToPng(svg)
  },
}

export default phosphorIconsPack
